/**
 * Every string `/pages/contact` renders.
 *
 * **No channel value lives here.** Every value on the page is operator data that
 * arrives from `backend-content`; what this file carries is the console's own
 * wording.
 */
export const copy = {
  crumb: 'اتصل بنا',

  head: {
    title: 'اتصل بنا',
    lede: 'قنوات التواصل التي تعرضها الصفحة العامّة «اتصل بنا»: رقم الدعم، والبريد، والعنوان، والموقع على الخريطة، والحسابات. خمس قنوات يسمّيها الفهرس، ولا سادسة.',
  },

  identity: {
    /** The two pages differ in shape, and this row is where that is stated. */
    bodyShape: 'سطر قائد وقنوات — لا كتل',
    note: 'هذه الصفحة لا تحمل جسماً حرّاً: العارض العامّ يضع تحت ترويستها بطاقة القنوات ونموذج التذكرة.',
  },

  lede: {
    hint: 'يظهر تحت عنوان الصفحة العامّة، فوق بطاقة القنوات.',
  },

  channels: {
    heading: 'قنوات التواصل',
    note: 'القيم كلّها بيانات مشغّل تظهر كما تُكتب هنا. الحقل الفارغ يختفي من الصفحة العامّة ولا يُكتب مكانه «غير متاح».',
    phone: { label: 'رقم الدعم', hint: 'بصيغة دولية. يُعرض للقارئ بأرقام هندية عربية.' },
    email: { label: 'البريد الإلكتروني' },
    address: { label: 'العنوان' },
    mapLabel: { label: 'اسم الموضع', hint: 'النصّ الذي يقرأه الزائر تحت صورة الموضع.' },
    mapUrl: {
      label: 'رابط الموقع على الخريطة',
      hint: 'يُفتح بنقرة صريحة. الصفحة العامّة لا تضمّن خريطة ولا تحمّل شيئاً من مزوّدها.',
    },
  },

  handles: {
    heading: 'الحسابات',
    add: 'أضف حساباً',
    note: 'صفر أو أكثر. تُعرض نصّاً لا شعارات.',
    label: 'التسمية',
    url: 'الرابط',
    remove: (label: string) => (label.length > 0 ? `احذف صفّ «${label}»` : 'احذف الصفّ الفارغ'),
    empty: 'لا حسابات. الصفحة العامّة تحذف الصفّ كلّه بدل أن تعرضه فارغاً — «أضف حساباً» يعيده.',
    announce: {
      added: 'أُضيف صفّ حساب فارغ.',
      removed: (label: string, remaining: string) => `حُذف صفّ ${label}. بقي ${remaining} حساباً.`,
    },
  },

  notHere: {
    heading: 'ما لا يُحرَّر من هنا',
    title: 'نموذج التذكرة ليس محتوى هذه الصفحة',
    bodyLead:
      'الصفحة العامّة تحمل تحت القنوات نموذجاً يفتح به المشترك تذكرة دعم. حقوله وأسباب التذكرة إعدادٌ للخدمة لا نصٌّ يُكتب هنا، والتذاكر نفسها تصل طابور ',
    link: 'الحالات',
    bodyTail: ' مع البلاغات وطلبات العناوين.',
  },

  saved: {
    /** See the sibling note in `../about/copy.ts`: the public page is purged on write. */
    body: 'حُفظت القنوات، وصفحة «اتصل بنا» العامّة تحمل الجديد فور تحديثها.',
  },
} as const;
